import axios from 'axios'
import endpoints from '../configuration/endpoints'

export const REQUEST_SHIP_STATEROOMS = 'REQUEST_SHIP_STATEROOMS'
export const RECEIVE_SHIP_STATEROOMS = 'RECEIVE_SHIP_STATEROOMS'
export const SHIP_STATEROOMS_ERROR = 'SHIP_STATEROOMS_ERROR'

const requestShipStateRoomsList = () => ({
  type: REQUEST_SHIP_STATEROOMS
})

const receiveShipStateRooms = availableStaterooms => ({
  type: RECEIVE_SHIP_STATEROOMS,
  payload: availableStaterooms
})

const receiveShipStateRoomsError = () => ({
  type: SHIP_STATEROOMS_ERROR
})

export const requestShipStateRooms = shipCode => dispatch => {
  dispatch(requestShipStateRoomsList)

  return axios
    .get(`${endpoints.stateroomTypes}${shipCode}`)
    .then(res => {
      dispatch(receiveShipStateRooms(res && res.data && res.data.data))
    })
    .catch(err => {
      console.log(err)
      dispatch(receiveShipStateRoomsError())
    })
}
